import { useAbility } from 'permissions/hooks/useAbility';
import { Actions, Subjects } from 'src/permissions/ability';
import { useHasFeatureFlag } from 'featureFlags/useHasFeatureFlag';

export const useSubscriptionStatusReconciliationAvailable = () => {
  const ability = useAbility();
  const hasFeatureFlag = useHasFeatureFlag('SubscriptionStatusManualReconciliation');

  return hasFeatureFlag && ability.can(Actions.upload, Subjects.subscriptionStatusReconciliation);
};
